// extracted by mini-css-extract-plugin
export default {"imageWrapper":"cK-z","twoColumnImage":"dK-z"};